import React from "react";
import { connect } from "react-redux";
import { withRouter, Link, NavLink } from "react-router-dom";
import { get } from "lodash";

import "./subHeader.scss";
import { subHeaderList } from "../constants/header";
import { resetField } from "../store/actions";

const SubHeader = ({ location, resetField, isAdmin }) => {
	const pathParams = location.pathname.split("/");

	const renderNav = () => {
		const navList = subHeaderList[pathParams[1]];
		if (navList && navList.length > 0) {
			return (
				<ul className="sub-nav">
					{navList.map(({ id, to, label, icon, exact = false, onlyAdmin = false, onlyUser = false }, index) => {
						const show = (!onlyAdmin || isAdmin) && (!onlyUser || !isAdmin)
						return (show ? (
							<li key={index}>
								<NavLink to={to} exact={exact} activeClassName="active">
									{icon && (
										<span className="nav-icon">
											<i className={`icon icon-${icon}`} />
										</span>
									)}
									<span className="nav-title">{label}</span>
								</NavLink>
							</li>
						) : null);
					})}
				</ul>
			);
		}
		return null;
	};

	const renderActionButtons = () => {
		const subHeaderItem = get(subHeaderList, pathParams[1], []).find((item) => item.to === location.pathname);
		if (subHeaderItem && subHeaderItem.actionButtons && subHeaderItem.actionButtons.length > 0) {
			return subHeaderItem.actionButtons.map((actionButton, i) => {
				return (!actionButton.onlyAdmin || (actionButton.onlyAdmin && isAdmin)) ? actionButton.to ? (
					<Link
						key={i}
						className={`btn mt-2 mb-2 ml-3 ${actionButton.className ? actionButton.className : "btn-primary"}`}
						to={actionButton.to}>
						<i className={`icon ${actionButton.icon}`} /> {actionButton.label}
					</Link>
				) : (
						<button
							key={i}
							type="button"
							className={`btn mt-2 mb-2 ml-3 ${actionButton.className ? actionButton.className : "btn-primary"}`}
							onClick={() => resetField(actionButton.click, actionButton.value)}>
							<i className={`icon ${actionButton.icon}`} /> {actionButton.label}
						</button>
					) : null;
			});
		}
		return null;
	};

	return (
		<section className="sub-nav print-hidden">
			<div className="container">
				<div className="sub-nav-container">{renderNav()}</div>
				<div className="related-nav-container">{renderActionButtons()}</div>
			</div>
		</section>
	);
};

const mapStateToProps = (state) => {
	const { Auth } = state;
	return {
		isAdmin: Auth.isAdmin
	};
};

const mapDispatchToProps = {
	resetField
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(SubHeader));
